import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { BitacoraDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class BitacoraService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getBitacoraService(): Observable<BodyListResponse<BitacoraDTO>> {
    return this.http.get<BodyListResponse<BitacoraDTO>>(API_URL + '/api/v1/bitacora/todos');
  }

  guardarBitacoraService(bitacoraDTO: BitacoraDTO): Observable<BodyResponse<BitacoraDTO>> {
    return this.http.post<BodyResponse<BitacoraDTO>>(API_URL + '/api/v1/bitacora', bitacoraDTO);
  }

  getBitacoraPorCodigoService(codigo: string): Observable<BodyResponse<BitacoraDTO>> {
    return this.http.get<BodyResponse<BitacoraDTO>>(API_URL + '/api/v1/bitacora/' + codigo);
  }
  /**********nuevo */

  getBitacoraPorCronogramaService(codigo: string): Observable<BodyListResponse<BitacoraDTO>> {
    return this.http.get<BodyListResponse<BitacoraDTO>>(API_URL + '/api/v1/bitacora/cronograma/' + codigo);
  }
}
